import { CaretDownIcon } from "@phosphor-icons/react/dist/csr/CaretDown";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@volca/ui/components/ui/collapsible";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { PayrollNoteActions } from "./note-actions";
import { PayrollNoteRow } from "./note-row";
import type { EnrichedPayrollPeriodNote } from "./types";

export const PayrollNoteHistory = ({
  businessId,
  periodStart,
  locked,
  reviewedNotes,
  sentNotes,
  open,
  onOpenChange,
}: {
  businessId: string | null;
  periodStart: string;
  locked: boolean;
  reviewedNotes: EnrichedPayrollPeriodNote[];
  sentNotes: EnrichedPayrollPeriodNote[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  if (reviewedNotes.length === 0 && sentNotes.length === 0) return null;

  return (
    <Collapsible open={open} onOpenChange={onOpenChange}>
      <CollapsibleTrigger className="flex items-center gap-1 text-xs text-subtle">
        <CaretDownIcon className="size-3" aria-hidden />
        History ({reviewedNotes.length + sentNotes.length})
      </CollapsibleTrigger>
      <CollapsibleContent>
        <Stack gap={3} className="mt-3">
          {reviewedNotes.length > 0 && <Text variant="label">Reviewed</Text>}
          {reviewedNotes.map((note) => (
            <PayrollNoteRow key={note.id} note={note}>
              {!locked && note.status === "addressed" && (
                <PayrollNoteActions
                  businessId={businessId}
                  periodStart={periodStart}
                  note={note}
                />
              )}
            </PayrollNoteRow>
          ))}
          {sentNotes.length > 0 && (
            <Text variant="label">Created for next open period</Text>
          )}
          {sentNotes.map((note) => (
            <PayrollNoteRow key={note.id} note={note} sent />
          ))}
        </Stack>
      </CollapsibleContent>
    </Collapsible>
  );
};
